import { ICONS } from '@/constants/icons';

/**
 * Single source of truth for how a media kind is drawn (Creator posts table badges, Release Board
 * media filter). A kind has either an icon-font glyph (`icon`) or a text glyph (`glyph`).
 */
export type MediaKind = 'image' | 'video' | 'document' | 'carousel' | 'text';

export interface MediaKindVisual {
  /** HappyIcons name (verified in happyicon.css) */
  icon?: string;
  /** Plain-text glyph used where the table badge uses one (video play mark) */
  glyph?: string;
}

export const MEDIA_KIND_VISUALS: Record<MediaKind, MediaKindVisual> = {
  image: { icon: ICONS.IMAGE },
  // `glyph` keeps the table badge text mark; `icon` is for aligned icon boxes (filter options).
  video: { icon: ICONS.PLAY, glyph: '▶' },
  document: { icon: ICONS.FILE },
  // Multi-image post: distinct carousel icon (the table badge adds the item count).
  carousel: { icon: ICONS.CAROUSEL },
  text: { icon: ICONS.TEXT_OUTLINE },
};
